import { IPage } from '../models/page-model';
import { Page } from '../models/page-viewmodel';

/**
 * Mapper for the Pages service
 */

export default class PagesMapper {
    public mapPage(item: IPage): Page {
        return new Page(
            item.id,
            item.title,
            item.url,
            item.addedDateTime
        );
    }
}
